import $http from '../../axios';
import {Notification} from 'element-ui';

/**
 * Request para obtener datos de branch_offices.
 */
export async function getBranchOffices({commit, state}) {

    let params = {
        paginate: false
    };

    if (!state.branch_offices.length) {
        await $http
            .get(`/api/sedes`, {params})
            .then(response => {
                commit('setBranchOffices', response.data.data);
            })
            .catch(error => {
                console.error(error);
            });
    }
}

/**
 * Request para obtener datos de branch_offices_warehouses.
 */
export async function getBranchOfficesWarehouses({commit, state}) {

    let params = {
        branchoffice_id: state.params.branch_office_id,
        paginate: false
    };

    if (!state.branch_offices_warehouses.length) {
        await $http
            .get(`/api/bodegas-sedes`, {params})
            .then(response => {
                commit('setBranchOfficesWarehouses', response.data.data);
            })
            .catch(error => {
                console.error(error);
            });
    }
}

/**
 * Request para obtener datos de models.
 */
export async function getModels({commit, state}) {
    if (!state.models.length) {
        await $http
            .get(`/api/modelos-punto-de-venta`)
            .then(response => {
                commit('setModels', response.data.data);
            })
            .catch(error => {
                console.error(error);
            });
    }
}

/**
 * Request para obtener datos de voucher_types.
 */
export async function getVoucherTypes({commit, state}) {

    let params = {
        branchoffice: state.params.branch_office_id
    };

    if (!state.voucher_types.length) {
        await $http
            .get(`/api/tipos-de-comprobantes`, {params})
            .then(response => {
                commit('setVoucherTypes', response.data.data);
            })
            .catch(error => {
                console.error(error);
            });
    }
}

/**
 * Request para obtener datos de contacts.
 */
export async function getContacts({commit, state}, filter) {
    if (filter.length >= 4) {
        state.params_contacts.type = 'is_customer';
        let params = state.params_contacts;
        params.filter = filter

        await $http.get('/api/terceros-lite', {params})
            .then(async response => {
                commit('setContacts', response.data.data);
            })
            .catch(error => {
                Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
            });
    }
}

/**
 * Request para obtener datos de documents.
 */
export async function getDocuments({commit, state, dispatch}, restart_page = true) {

    const selectedModel = state.models.find(m => m.id === state.params.model_id);

    if (restart_page) {
        commit('setPageToParams', 1);
    }

    let params = state.params;
    params.closed = null;

    if (state.base_document && selectedModel.code === "010") {
        params.closed = false;
    }

    await $http
        .get(`/api/buscar-documentos`, {params})
        .then(response => {
            commit('setDocuments', response.data.data);

            if (selectedModel.code === "010") {
                dispatch("fetchUnds", response.data.data.data);
            }
        })
        .catch(error => {
            console.error(error);
        });
}

export async function fetchUnds({commit, state}, documents){
    
    let documents_id = []
    await documents.map(doc => {
      documents_id.push(doc.id)
    });
  
    const chunks = [];
    for (let i = 0; i < documents_id.length; i += 50) {
        chunks.push(documents_id.slice(i, i + 50));
    }
  
    await chunks.forEach(async docs => {
      let params = {
        'documents_id'  : docs,
        'model_id'      : state.params.model_id
      }
      await $http
        .post(`/api/unds`, params)
        .then(response => {
          commit("setUnds", response.data.data);
        })
        .catch(error => {
          console.error(error);
        });
    });
  
  
  }

/**
 * Obtener documento.
 */
export async function getDocument({commit, state, dispatch}, document) {

    let params = {
        model_id: document.model_id
    };

    return new Promise(async (resolve, reject) => {
        await $http.get('/api/documento-por-id/' + document.id, {params})
            .then(async response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
    });

}



// WEBPACK FOOTER //
// ./src/modules/document_finder/actions.js